import { Modal } from "react-bootstrap";

export default function ModalSuccess({ modalSuccess, setModalSuccess }) {
    return modalSuccess ? <Modal
        show={true}
        onHide={() => setModalSuccess(false)}
        centered
    >
        <Modal.Body>
            <div>
                <img
                    onClick={() => setModalSuccess(false)}
                    className="btn-close-img"
                    src="/closeBtn.svg"
                    alt="close"
                />
            </div>
            <div
                style={{
                    textAlign: "center",
                    paddingTop: "50px",
                    paddingBottom: "80px",
                }}
            >
                <div
                    style={{
                        fontSize: "60px",
                        marginBottom: "10px",
                    }}
                >
                    ✅
                </div>
                <div
                    style={{
                        color: "#28a745",
                        fontSize: "1.4em",
                        fontWeight: "500",
                        marginTop: "20px",
                        marginBottom: "0px",
                    }}
                >
                    {typeof modalSuccess === "string" ? modalSuccess : "Operazione completata con successo"}
                    <br></br>
                </div>
            </div>
        </Modal.Body>
    </Modal> : <span></span>;
}
